module.exports = __webpack_public_path__ + "static/media/coupons.9f8cf460.png";